export enum GameState {
    Idle,
    Playing,
    Lose,
    Victory
}